import React__default from 'react';
import { Builds } from './BuildsPage/BuildsPage.esm.js';
import { ContextProvider } from './ContextProvider.esm.js';

const TravisCIBuildsPage = ({ entity }) => {
  return /* @__PURE__ */ React__default.createElement(ContextProvider, { entity }, /* @__PURE__ */ React__default.createElement(Builds, null));
};

export { TravisCIBuildsPage };
//# sourceMappingURL=TravisCiBuildsPage.esm.js.map
